import React from 'react';
import useReviews from '../../hooks/useReviews';
import { Swiper, SwiperSlide } from "swiper/react";
import reviewBackground from '../../assets/others/review-background.svg';
import quot from '../../assets/others/quot.png';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import required modules
import { Pagination } from "swiper";
// custom css
import './Reviews.css';


const Reviews = () => {
    const [reviews] = useReviews();

    return (
        <section className='bg-accent'>
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                breakpoints={{
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                }}

                modules={[Pagination]}
                className="mySwiper swiper-mx"
            >
                {
                    reviews.map(review =>
                        <SwiperSlide className='my-20 mb-32'>
                            <img className='relative' src={reviewBackground} alt="" />
                            <div className='h-80 absolute top-16 left-4 rounded-3xl bg-white shadow-lg px-6 pb-4 pt-7 mb-10'>
                                <div className='flex'>
                                    <img className='w-16 h-16 ' src={review.img} alt="" />
                                    <h5 className='text-2xl ml-3'>{review.name}</h5>
                                    {/* <p className='font-bold text-center'>Rating: {review.rating}</p> */}
                                </div>
                                <p className='pt-5'>{review.review.slice(0, 280)}...</p>
                                <div className='absolute top-[-17px]'>
                                    <img src={quot} alt="" />
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                }

            </Swiper>
        </section>
    );
};

export default Reviews;